
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 
 import {ObcCheckboxItem as ObcCheckboxItemElement} from '@oicl/openbridge-webcomponents/dist/components/checkbox-item/checkbox-item.js';
 import {ObcCheckboxChangeEvent} from '@oicl/openbridge-webcomponents/dist/components/checkbox/checkbox.js';
 export type {ObcCheckboxChangeEvent} from '@oicl/openbridge-webcomponents/dist/components/checkbox/checkbox.js';
 

 
 export const ObcCheckboxItem = createComponent({
   react: React,
   tagName: 'obc-checkbox-item',
   elementClass: ObcCheckboxItemElement,
   events: {
     
     onChange: 'change' as EventName<ObcCheckboxChangeEvent>,
   }
  });
 
 